import { useEffect, useState } from "react";
import { useLazyGetPermitRegisterPolicies } from "../operations/queries/getPermitRegisterPolicies";
import {
  ADD_PERMIT,
  APPROVE_PERMIT_REQUEST,
  EXTEND_PERMIT,
  REQUEST_PERMIT,
  DOWNLOAD_PERMIT_PDF,
  COMPLETE_PERMIT,
  CANCEL_PERMIT,
  CANCEL_OWN_PERMIT,
  UNDO_CANCELLATION_PERMIT,
  UNDO_CANCELLATION_OWN_PERMIT,
  ADD_DOCUMENT,
  ADD_NEW_DOCUMENT_VERSION,
  DELETE_DOCUMENT,
} from "../models/Policies";
import { useAppContext } from "./useAppContext";

export function usePermitRegisterPolicies(permitTypeId?: string) {
  const [permitRegisterPolicies, setPermitRegisterPolicies] = useState<string[]>();
  const { currentPermitRegister } = useAppContext();
  const { getPermitRegisterPolicies, data } = useLazyGetPermitRegisterPolicies();

  useEffect(() => {
    if (currentPermitRegister) {
      getPermitRegisterPolicies({
        variables: {
          permitRegisterId: currentPermitRegister.id,
          permitTypeId: permitTypeId ?? null,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPermitRegister, permitTypeId]);

  useEffect(() => {
    if (data) {
      setPermitRegisterPolicies(data.permitRegisterPolicies);
    }
  }, [data]);

  const authorize = (policy: string): boolean => {
    return permitRegisterPolicies ? permitRegisterPolicies.includes(policy) : false;
  };

  const authorizedToApprovePermit = authorize(APPROVE_PERMIT_REQUEST.name);
  const authorizedToAddPermit = authorize(ADD_PERMIT.name);
  const authorizedToRequestPermit = authorize(REQUEST_PERMIT.name);
  const authorizedToDownloadPermitPdf = authorize(DOWNLOAD_PERMIT_PDF.name);
  const authorizedToExtendPermit = authorize(EXTEND_PERMIT.name);
  const authorizedToCompletePermit = authorize(COMPLETE_PERMIT.name);
  const authorizedToCancelOwnPermit = authorize(CANCEL_OWN_PERMIT.name);
  const authorizedToCancelPermit = authorize(CANCEL_PERMIT.name);
  const authorizedToUndoCancellationOwnPermit = authorize(UNDO_CANCELLATION_OWN_PERMIT.name);
  const authorizedToUndoCancellationPermit = authorize(UNDO_CANCELLATION_PERMIT.name);
  const authorizedToAddDocument = authorize(ADD_DOCUMENT.name);
  const authorizedToAddNewDocumentVersion = authorize(ADD_NEW_DOCUMENT_VERSION.name);
  const authorizedToDeleteDocument = authorize(DELETE_DOCUMENT.name);

  return {
    permitRegisterPolicies,
    authorize,
    authorizedToApprovePermit,
    authorizedToAddPermit,
    authorizedToRequestPermit,
    authorizedToDownloadPermitPdf,
    authorizedToExtendPermit,
    authorizedToCompletePermit,
    authorizedToCancelOwnPermit,
    authorizedToCancelPermit,
    authorizedToUndoCancellationOwnPermit,
    authorizedToUndoCancellationPermit,
    authorizedToAddDocument,
    authorizedToAddNewDocumentVersion,
    authorizedToDeleteDocument,
  };
}
